import { IconAlertCircleFilled } from '@tabler/icons-react';
import type { Issue } from '../../shared/contracts';
import { issueSummary } from '../issues';

export function IssueDot({ issues }: { issues: readonly Issue[] }) {
  if (issues.length === 0) return null;
  return (
    <span
      role="img"
      aria-label={`Needs attention: ${issueSummary(issues)}`}
      className="text-attention bg-surface absolute -top-2 -right-2 inline-flex rounded-full"
    >
      <IconAlertCircleFilled size={20} aria-hidden />
    </span>
  );
}
